import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import { handlers as guestJourneyReportsHandlers } from './guest-journey-reports.mock';
import { salesByLocation } from './fixtures/sales-summary.fixture';
import { allItems } from './fixtures/all-items.fixture';
import { menuGroups } from './fixtures/menu-groups.fixture';
import { locations } from './fixtures/location.fixture';
import { giftCardPoolReport } from './fixtures/gift-card-pool-report.fixture';
import {
  brandOrders,
  brandPointsSummary,
  brandSummary,
  brandSignupAggregate,
  brandSignupTimeSeries,
  franchiseSummary,
  franchiseActiveMembers,
  franchiseLoyaltySales,
  locationsPerformanceSummary,
  locationsPerformanceData,
  locationsTrends,
  offersPerformanceSummary,
  offersPerformanceData,
  offersTrends,
  availableOffers,
} from './fixtures/loyalty-reports.fixture';
import {
  emailPulseOverviewSummary,
  emailPulseEmailsOpenedBreakdown,
  emailPulseEmailsBouncedBreakdown,
  emailPulseOverviewTrends,
  emailPulseOverviewData,
  emailPulseMarketingSummary,
  emailPulseMarketingEmailsOpenedBreakdown,
  emailPulseMarketingEmailsBouncedBreakdown,
  emailPulseMarketingData,
  emailPulseOrdersSummary,
  emailPulseOrdersEmailsOpenedBreakdown,
  emailPulseOrdersEmailsBouncedBreakdown,
  emailPulseOrdersData,
  emailPulseGiftCardsSummary,
  emailPulseGiftCardsEmailsOpenedBreakdown,
  emailPulseGiftCardsEmailsBouncedBreakdown,
  emailPulseGiftCardsData,
  emailPulseSecuritySummary,
  emailPulseSecurityEmailsOpenedBreakdown,
  emailPulseSecurityEmailsBouncedBreakdown,
  emailPulseSecurityData,
  emailPulseOffersData,
  pulseOffers,
  pulseMessages,
} from './fixtures/email-pulse.fixture';

import {
  recommendationsSummary,
  recommendationsTopItems,
  recommendationsAverageBasketValue,
} from './fixtures/recommendations.fixture';
import { jobsStatus } from './fixtures/jobsStatus/jobs-status.fixture';

export const listMenuItemsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/menuintelligence/itemMetrics`,
    fn,
  );

export const getMenuGroupsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/menuintelligence/groups`,
    fn,
  );

export const getLocationsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/menuintelligence/locations`,
    fn,
  );

export const exportCsvMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/menuintelligence/itemMetrics/export`,
    fn,
  );

export const getGiftCardPoolReportMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/clients/:clientId/giftcardpoolsummary`,
    fn,
  );

export const exportGiftCardPoolReportMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/clients/:clientId/giftcardpoolsummary/download-csv`,
    fn,
  );

export const getSalesByLocationMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/clients/:clientId/sales-by-location`,
    fn,
  );

export const exportCustomersCSVMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/clients/customers/download-active`,
    fn,
  );

export const exportCustomersCSVDownloadedResponse = {
  status: 'DOWNLOADED',
  responseMessage: 'DOWNLOADED',
  data: {
    REPORT: '"Customer ID","First Name"',
  },
};

export const exportOfferPerformanceCSVMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/offers/performance/csv`,
    fn,
  );

export const exportLocationsPerformanceCSVMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/locations/performance/csv`,
    fn,
  );

export const exportOfferTrendsCSVMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/offers/trends/csv`,
    fn,
  );

export const exportLocationsTrendsCSVMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/locations/trends/csv`,
    fn,
  );

export const brandOrdersMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/brand/orders`,
    fn,
  );

export const brandPointsSummaryMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/brand/pointssummary`,
    fn,
  );

export const brandSummaryMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/brand/summary`,
    fn,
  );

export const brandSignupAggregateMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/brand/signup/aggregate`,
    fn,
  );

export const brandSignupTimeSeriesMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/brand/signup/timeseries`,
    fn,
  );

export const franchiseSummaryMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/franchise/summary`,
    fn,
  );

export const locationsPerformanceSummaryMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/locations/performance/summary`,
    fn,
  );

export const locationsPerformanceDataMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/locations/performance/data`,
    fn,
  );

export const locationsTrendsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/locations/trends`,
    fn,
  );

export const franchiseAciveMembersMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/franchise/activemembers`,
    fn,
  );

export const franchiseLoyaltySalesMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/franchise/loyaltysales`,
    fn,
  );

export const offersPerformanceSummaryMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/offers/performance/summary`,
    fn,
  );

export const offersPerformanceDataMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/offers/performance/data`,
    fn,
  );

export const offersTrendsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/loyaltyreport/offers/trends`,
    fn,
  );

// Email Pulse consolidated mocks
export const getEmailPulseSummaryMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/pulse/email/:reportType/cards`,
    fn,
  );

export const getEmailPulseEmailsOpenedBreakdownMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/pulse/email/:reportType/opened`,
    fn,
  );

export const getEmailPulseEmailsBouncedBreakdownMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/pulse/email/:reportType/bounced`,
    fn,
  );

export const getEmailPulseTrendsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/pulse/email/overview/trends`,
    fn,
  );

export const getEmailPulseDataMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/pulse/email/:reportType/data`,
    fn,
  );

export const exportEmailPulseMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/pulse/email/:reportType/data/csv`,
    fn,
  );

export const getPulseOffersMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/pulse/email/offers`,
    fn,
  );

export const getPulseMessagesMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/pulse/email/messages`,
    fn,
  );

export const getRecommendationsSummaryMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/clients/:clientId/recommendation-dashboard/summary`,
    fn,
  );

export const getRecommendationsTopItemsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/clients/:clientId/recommendation-dashboard/top-items`,
    fn,
  );

export const getRecommendationsAverageBasketValueMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-reports/clients/:clientId/recommendation-dashboard/average-basket-value`,
    fn,
  );

export const getJobsStatusMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-reports/jobs/status`,
    fn,
  );

export const getAvailableOffersMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-reports/offers/available`,
    fn,
  );

export const handlers = () => [
  getSalesByLocationMock((req, res, ctx) => {
    return res(ctx.json(salesByLocation));
  }),
  listMenuItemsMock((_req, res, ctx) => {
    return res(ctx.json(allItems));
  }),
  getMenuGroupsMock((_req, res, ctx) => {
    return res(ctx.json(menuGroups));
  }),
  getLocationsMock((_req, res, ctx) => {
    return res(ctx.json(locations));
  }),
  exportCsvMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  getGiftCardPoolReportMock((req, res, ctx) => {
    return res(
      ctx.json({
        amountByLocationList: giftCardPoolReport.amountByLocationList,
        amountByPoolAccount: giftCardPoolReport.amountByPoolAccount,
        amountByBonusAccount: giftCardPoolReport.amountByBonusAccount,
      }),
    );
  }),

  exportGiftCardPoolReportMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  exportCustomersCSVMock((_req, res, ctx) => {
    return res(
      ctx.json({
        status: 'EMAILED',
        responseMessage:
          'Report has been emailed. Please wait 15 minutes before rerunning this report again.',
        data: {},
      }),
    );
  }),

  exportOfferPerformanceCSVMock((_req, res, ctx) => {
    return res(
      ctx.json({
        status: 'EMAILED',
        responseMessage:
          'Report has been emailed. Please wait 15 minutes before rerunning this report again.',
        data: {},
      }),
    );
  }),

  exportOfferTrendsCSVMock((_req, res, ctx) => {
    return res(
      ctx.json({
        status: 'EMAILED',
        responseMessage:
          'Report has been emailed. Please wait 15 minutes before rerunning this report again.',
        data: {},
      }),
    );
  }),

  exportLocationsTrendsCSVMock((_req, res, ctx) => {
    return res(
      ctx.json({
        status: 'EMAILED',
        responseMessage:
          'Report has been emailed. Please wait 15 minutes before rerunning this report again.',
        data: {},
      }),
    );
  }),

  exportLocationsPerformanceCSVMock((_req, res, ctx) => {
    return res(
      ctx.json({
        status: 'EMAILED',
        responseMessage:
          'Report has been emailed. Please wait 15 minutes before rerunning this report again.',
        data: {},
      }),
    );
  }),

  brandOrdersMock((_req, res, ctx) => {
    return res(ctx.json(brandOrders));
  }),

  brandPointsSummaryMock((_req, res, ctx) => {
    return res(ctx.json(brandPointsSummary));
  }),

  brandSummaryMock((_req, res, ctx) => {
    return res(ctx.json(brandSummary));
  }),

  brandSignupAggregateMock((_req, res, ctx) => {
    return res(ctx.json(brandSignupAggregate));
  }),

  brandSignupTimeSeriesMock((_req, res, ctx) => {
    return res(ctx.json(brandSignupTimeSeries));
  }),

  franchiseSummaryMock((_req, res, ctx) => {
    return res(ctx.json(franchiseSummary));
  }),

  locationsPerformanceSummaryMock((_req, res, ctx) => {
    return res(ctx.json(locationsPerformanceSummary));
  }),

  locationsTrendsMock((_req, res, ctx) => {
    return res(ctx.json(locationsTrends));
  }),

  locationsPerformanceDataMock((_req, res, ctx) => {
    return res(ctx.json(locationsPerformanceData));
  }),

  franchiseAciveMembersMock((_req, res, ctx) => {
    return res(ctx.json(franchiseActiveMembers));
  }),

  franchiseLoyaltySalesMock((_req, res, ctx) => {
    return res(ctx.json(franchiseLoyaltySales));
  }),

  offersPerformanceSummaryMock((_req, res, ctx) => {
    return res(ctx.json(offersPerformanceSummary));
  }),

  offersPerformanceDataMock((_req, res, ctx) => {
    return res(ctx.json(offersPerformanceData));
  }),

  offersTrendsMock((_req, res, ctx) => {
    return res(ctx.json(offersTrends));
  }),

  // Email Pulse consolidated handlers
  getEmailPulseSummaryMock((req, res, ctx) => {
    const { reportType } = req.params;
    const fixtureMap = {
      OVERVIEW: emailPulseOverviewSummary,
      MESSAGES: emailPulseMarketingSummary,
      OFFERS: emailPulseMarketingSummary,
      ORDERS: emailPulseOrdersSummary,
      GIFT_CARDS: emailPulseGiftCardsSummary,
      SECURITY: emailPulseSecuritySummary,
    };
    return res(ctx.json(fixtureMap[reportType as string]));
  }),

  getEmailPulseEmailsOpenedBreakdownMock((req, res, ctx) => {
    const { reportType } = req.params;
    const fixtureMap = {
      OVERVIEW: emailPulseEmailsOpenedBreakdown,
      MESSAGES: emailPulseMarketingEmailsOpenedBreakdown,
      OFFERS: emailPulseMarketingEmailsOpenedBreakdown,
      ORDERS: emailPulseOrdersEmailsOpenedBreakdown,
      GIFT_CARDS: emailPulseGiftCardsEmailsOpenedBreakdown,
      SECURITY: emailPulseSecurityEmailsOpenedBreakdown,
    };
    return res(ctx.json(fixtureMap[reportType as string]));
  }),

  getEmailPulseEmailsBouncedBreakdownMock((req, res, ctx) => {
    const { reportType } = req.params;
    const fixtureMap = {
      OVERVIEW: emailPulseEmailsBouncedBreakdown,
      MESSAGES: emailPulseMarketingEmailsBouncedBreakdown,
      OFFERS: emailPulseMarketingEmailsBouncedBreakdown,
      ORDERS: emailPulseOrdersEmailsBouncedBreakdown,
      GIFT_CARDS: emailPulseGiftCardsEmailsBouncedBreakdown,
      SECURITY: emailPulseSecurityEmailsBouncedBreakdown,
    };
    return res(ctx.json(fixtureMap[reportType as string]));
  }),

  getEmailPulseTrendsMock((_req, res, ctx) => {
    return res(ctx.json(emailPulseOverviewTrends));
  }),

  getEmailPulseDataMock((req, res, ctx) => {
    const { reportType } = req.params;
    const fixtureMap = {
      OVERVIEW: emailPulseOverviewData,
      MESSAGES: emailPulseMarketingData,
      OFFERS: emailPulseOffersData,
      ORDERS: emailPulseOrdersData,
      GIFT_CARDS: emailPulseGiftCardsData,
      SECURITY: emailPulseSecurityData,
    };
    return res(ctx.json(fixtureMap[reportType as string]));
  }),

  exportEmailPulseMock((_req, res, ctx) => {
    return res(
      ctx.json({
        status: 'SUCCESS',
        responseMessage: 'CSV generated successfully',
        data: {
          REPORT: '"Column1","Column2","Column3"\n"Value1","Value2","Value3"\n',
        },
      }),
    );
  }),

  getPulseOffersMock((_req, res, ctx) => {
    return res(ctx.json(pulseOffers));
  }),

  getPulseMessagesMock((_req, res, ctx) => {
    return res(ctx.json(pulseMessages));
  }),

  getRecommendationsSummaryMock((_req, res, ctx) => {
    return res(ctx.json(recommendationsSummary));
  }),

  getRecommendationsTopItemsMock((_req, res, ctx) => {
    return res(ctx.json(recommendationsTopItems));
  }),

  getRecommendationsAverageBasketValueMock((_req, res, ctx) => {
    return res(ctx.json(recommendationsAverageBasketValue));
  }),

  ...guestJourneyReportsHandlers(),
  getJobsStatusMock((_req, res, ctx) => {
    return res(ctx.json(jobsStatus));
  }),

  getAvailableOffersMock((_req, res, ctx) => {
    return res(ctx.json(availableOffers));
  }),
];
